<div [formGroup]="form">
    <app-form-dropdown
        controlName="code"
        [options]="(addressesOptions$ | async) || []"
        [placeholder]="'dropdown.placeholder.select-address' | translate"
    ></app-form-dropdown>
</div>
